<template>
  <div class="search-result-container" ref="resultContainer">
    <!-- 关闭按钮：保留原逻辑 -->
    <div style="padding: 10px 20px 0; text-align: right">
      <i class="el-icon-close" style="cursor: pointer" @click="clossWorkBench"></i>
    </div>

    <div style="padding: 0 20px 20px">
      <!-- 结果概览 -->
      <!-- <div class="result-overview">
        <el-breadcrumb separator="/">
        </el-breadcrumb>
        <div class="result-count">
          共找到 <span class="count-highlight">{{ content.total }}</span> 条相关结果
        </div>
      </div> -->

      <!-- 结果列表容器（控制列布局） -->
      <div class="result-list">
        <!-- 结果列表：从content.data_list中获取数据 -->
        <el-card class="result-card" shadow="hover" v-for="(item, index) in currentPageData" :key="index">
          <div class="result-header">
            <!-- 标题 + DOI -->
            <div class="title-container">
              <h3 class="result-title">
                <a href="javascript:void(0);" @click="openArticleInRightPanel(item)" rel="noopener noreferrer">
                  {{ item.title }}
                </a>
              </h3>
              <span class="doi-link" title="点击跳转至DOI页面">{{ cleanDoi(item.doi) }}</span>
            </div>

            <!-- 基础信息标签：新增【期刊名称】标签（核心修改点） -->
            <div class="basic-info">
              <el-tag size="mini" style="color: var(--tag-color-blue); background-color: var(--tag-bg-blue)">{{ item.pub_year }}年</el-tag>
              <el-tag size="mini" style="color: var(--tag-color-green); background-color: var(--tag-bg-green)">{{ item.language?.[0] || "未知" }}</el-tag>
              <el-tag size="mini" style="color: var(--tag-color-gary); background-color: var(--tag-bg-gary)">
                {{ item.isOa === 20 ? "开放获取" : "非开放获取" }}
              </el-tag>
              <el-tag size="mini" style="color: var(--tag-color-orange); background-color: var(--tag-bg-orange)">{{ item.publisher }}</el-tag>
              <!-- 新增：期刊名称标签，为空时显示“未标注” -->
              <el-tag size="mini" style="color: var(--tag-color-red); background-color: var(--tag-bg-red)">{{ item.journal || "未标注" }}</el-tag>
            </div>
          </div>

          <!-- 作者信息（兼容匿名作者） -->
          <div class="author-info">
            <span class="info-label">作者：</span>
            <span class="author-names">
              {{ item.author?.[0] === "- -" ? "匿名" : item.author?.join("，") || "未标注" }}
            </span>
          </div>

          <!-- 操作栏 -->
          <div class="action-bar">
            <el-button size="mini" type="text" @click="copyDoi(item.doi)" icon="el-icon-document-copy"> 复制DOI </el-button>
            <a size="mini" type="text" 
              href="javascript:void(0);" 
              rel="noopener noreferrer"
              class="el-button el-button--text el-button--mini result-link"
              @click="openArticleInRightPanel(item)"
              v-if="item.url && item.url.trim()">
              <i class="el-icon-link"></i>
              <span>查看详情</span>
            </a>
          </div>
        </el-card>
      </div>

      <!-- 空状态提示（判断content中数据是否为空） -->
      <el-empty description="暂无检索结果，请调整检索条件后重试" v-if="(content.data_list?.length === 0 || !content.data_list) && content.total === 0">
        <!-- <el-button type="primary" @click="$emit('request-refresh')">重新检索</el-button> -->
      </el-empty>

      <!-- 分页控件（基于content.total渲染） -->
      <div class="pagination-container" v-if="content.total > 0">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="content.total > 100 * 10 ? 100 * 10 : content.total"> </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { openArticleDetail } from "../utils/openArticleDetail";
import EventBus from '../eventBus/EventBus.js';
import { cleanDoi } from "@/utils/doiUtils";
/* eslint-disable */
export default {
  name: "WorkBench_WordSegmentList",
  props: {
    // 父组件传入的字典参数：含total（总结果数）和data_list（结果列表）
    content: {
      type: Object,
      required: true,
      // 默认值确保组件初始化时不报错（新增journal字段默认空，避免异常）
      default: () => ({
        total: 0,
        data_list: [],
        search_dict: {},
      }),
    },
  },
  data() {
    return {
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页条数
    };
  },
  computed: {
    // 直接返回后端返回的当前页数据，无需切片
    currentPageData() {
      return this.content.data_list || [];
    },
  },
  methods: {
    clossWorkBench() {
      this.$emit("clossWorkBench");
    },
    jyx_word_segment_search(search_dict, page_num, page_size) {
      this.$http.get(this.globalUrl.jyx_word_segment_search, { params: { search_dict: encodeURIComponent(JSON.stringify(search_dict)), page_num: page_num, page_size: page_size } }).then(res => {
        this.$set(this.content, "data_list", res.data.data_list);
        this.$set(this.content, "total", res.data.total);
        this.$set(this.content, "search_dict", res.data.search_dict);
      });
    },
    // 每页条数改变：重置为第一页并滚动到顶部
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.$refs.resultContainer.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    // 当前页码改变：滚动到顶部并请求新数据
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$refs.resultContainer.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      // 调用分词检索获取下一页的结果并渲染
      this.jyx_word_segment_search(this.content.search_dict, this.currentPage, this.pageSize);
    },
    cleanDoi(doi) {
      return cleanDoi(doi);
    },
    // 复制DOI到剪贴板（带成功提示）
    copyDoi(doi) {
      const pureDoi = cleanDoi(doi);
      try {
        // 现代浏览器推荐使用Clipboard API
        navigator.clipboard
          .writeText(pureDoi)
          .then(() => {
            this.$message.success("DOI复制成功");
          })
          .catch(() => {
            this.fallbackCopyDoi(pureDoi); // 降级处理
          });
      } catch (e) {
        this.fallbackCopyDoi(pureDoi); // 兼容不支持Clipboard API的环境
      }
    },
    // 在右侧面板打开文章
    openArticleInRightPanel(article) {
      // 发送兴趣保存请求 
      this.$http.post(this.globalUrl.interest_save, {interest: article.title})
        .then(response => {
          console.log('兴趣保存成功', response);
        })
        .catch(error => {
          console.error('兴趣保存失败', error);
        });
      
      openArticleDetail(article);
    },
    // 降级复制方法（兼容旧浏览器）
    fallbackCopyDoi(doi) {
      const input = document.createElement("input");
      input.value = doi;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$message.success("DOI复制成功");
    },
  },
};
</script>

<style scoped>
.search-result-container {
  background-color: var(--label-bg2);
  min-height: calc(100vh - 120px);
  overflow-y: auto;
  height: 100%;
  /* padding-top: 30px; */
}
.result-overview {
  margin-bottom: 24px;
}

.result-count {
  margin-top: 12px;
  font-size: 14px;
  color: var(--label-color);
}

.count-highlight {
  /* color: #3498db; */
  color: var(--a-color);
  font-weight: bold;
  font-size: 15px;
}

/* 结果列表容器（控制列布局） */
.result-list {
  display: grid;
  grid-template-columns: 1fr; /* 默认1列（宽度≤800px时） */
  gap: 16px; /* 卡片间距（垂直+水平） */
  margin-bottom: 20px; /* 与分页控件间距 */
}

/* 响应式：宽度>800px时切换为2列 */
@media (min-width: 801px) {
  .result-list {
    grid-template-columns: repeat(2, 1fr); /* 2列等宽 */
  }
  /* 2列时微调文字大小，优化显示效果 */
  .result-title {
    font-size: 15px;
  }
  .author-info {
    font-size: 13px;
  }
}

/* 结果卡片样式调整（适配多列） */
.result-card {
  margin-bottom: 0; /* 移除原底部margin，改用grid的gap控制 */
  height: 100%; /* 确保同列卡片高度一致 */
  display: flex;
  flex-direction: column; /* 让操作栏固定在底部 */
  transition: all 0.3s ease;
  border-radius: 8px;
}

.result-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

.result-header {
  margin-bottom: 12px;
}

.title-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.result-title {
  font-size: 16px;
  color: var(--a-color);
  margin: 0;
  cursor: pointer;
  transition: color 0.2s;
  word-break: break-word;
}
/* 移除a标签下划线 */
.result-title a {
  text-decoration: none;
  color: inherit;
}
.result-title a:hover {
  text-decoration: underline;
}

.result-link {
  text-decoration: none;
}
.result-link:hover {
  text-decoration: underline;
}

.result-title:hover {
  color: var(--a-color-hover);
}

.doi-link {
  font-size: 12px;
  color: var(--label-color);
  text-decoration: underline;
  transition: color 0.2s;
  word-break: break-all;
}

/* .doi-link:hover {
  color: var(--a-color);
} */

/* 基础信息标签区：兼容多标签换行，保持间距 */
.basic-info {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
  align-items: center;
}

.author-info {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  color: var(--label-color);
  flex-wrap: wrap;
}

.info-label {
  font-weight: 500;
  color: var(--label-color);
  margin-right: 8px;
}

.author-names {
  word-break: break-all;
  flex: 1;
}

/* 操作栏固定在卡片底部 */
.action-bar {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: auto; /* 自动顶开上方内容，固定在底部 */
  padding-top: 12px; /* 与上方内容间距 */
}

.pagination-container {
  margin-top: 32px;
  display: flex;
  justify-content: center;
}

/* 适配小屏幕（手机/平板）：标签自动换行，避免溢出 */
@media (max-width: 768px) {
  .search-result-container {
    padding: 10px;
  }

  .result-title {
    font-size: 14px;
  }

  .basic-info {
    gap: 4px; /* 缩小间距，适配小屏幕 */
  }

  .el-tag {
    font-size: 11px;
    padding: 2px 6px;
  }

  .pagination-container {
    margin-top: 20px;
  }
}
</style>
